let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lASPk")).then(() => parcelRequire('cYXPO'));